module.exports = __webpack_public_path__ + "img/taili12.54b3de36.jpg";